import PropTypes from "prop-types"
import React from "react"

import AlertBanner from "src/components/AlertBanner"

const bannerText = (surcharge, paymentCheck) => {
  if (paymentCheck?.surchargeApplies) return surcharge.creditNotice
  if (paymentCheck?.funding && paymentCheck.funding !== "credit") return null

  return surcharge.notice
}

const CardSurchargeBanner = ({ surcharge, paymentCheck }) => {
  if (!surcharge?.eligible) return null

  const text = bannerText(surcharge, paymentCheck)
  if (!text) return null

  return <AlertBanner type="warning">{text}</AlertBanner>
}

CardSurchargeBanner.propTypes = {
  surcharge: PropTypes.shape({
    eligible: PropTypes.bool,
    notice: PropTypes.string,
    creditNotice: PropTypes.string,
  }),
  paymentCheck: PropTypes.shape({
    funding: PropTypes.string,
    surchargeApplies: PropTypes.bool,
  }),
}

export default CardSurchargeBanner
